import { render, staticRenderFns } from "./BiobankCardsContainer.vue?vue&type=template&id=d239a054&"
import script from "./BiobankCardsContainer.vue?vue&type=script&lang=js&"
export * from "./BiobankCardsContainer.vue?vue&type=script&lang=js&"
import style0 from "./BiobankCardsContainer.vue?vue&type=style&index=0&id=d239a054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports